import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pause" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Paused ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-centered" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "images/IMG_line_divider.png",
    class: "k-pause-menu-divider"
  })
], -1)
const _hoisted_4 = {
  class: "px3 mt3 fit",
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Restart Game ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Your score will be discarded. ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-slash-square",
  style: {"font-size":"20px"}
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" End Game ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" And return to menu. ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Menu ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Continue ")

import NavigableScreen from 'components/navigable-screen.vue';
    import NavButton from 'components/nav-button.vue';
    import AudioToggleButton from 'components/audio-toggle-button.vue';
    import Button from 'components/button.vue';
    import CheckboxButton from 'components/checkbox-button.vue';
    import { resumeBanner, hideBanner } from 'util/ad-util';
    import { onBeforeUnmount, computed } from 'vue';
    import { useModule  } from 'src/modules/modules';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'pause-menu',
  emits: ['unpause', 'menu', 'end', 'restart', 'reduceFlashing'],
  setup(__props, { emit }) {

    const { global } = useModule();
    

    //TODO: don't bother w/ all these events and just set this shit right here (except for maybe pausing?)

    const reduceFlashingComputed = computed({
        get(){
            return global.reduceFlashing
        },
        set(val){
            global.setReduceFlashing(val);
        }
    })

    resumeBanner();
    onBeforeUnmount(() => {
        hideBanner();
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigableScreen, {
    "use-banner-offset": "",
    class: "au-pause-screen absolute-full-cover ios-inset-padding"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Button, {
          class: "k-pause-menu-btn mb2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('restart')))
        }, {
          icon: _withCtx(() => [
            _hoisted_5
          ]),
          label: _withCtx(() => [
            _hoisted_6
          ]),
          sublabel: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(Button, {
          class: "k-pause-menu-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('end')))
        }, {
          icon: _withCtx(() => [
            _hoisted_8
          ]),
          label: _withCtx(() => [
            _hoisted_9
          ]),
          sublabel: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ]),
    "nav-left": _withCtx(() => [
      _createVNode(NavButton, {
        type: "back",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('menu')))
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    "nav-right": _withCtx(() => [
      _createVNode(NavButton, {
        type: "next",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('unpause')))
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})